module.exports = __webpack_public_path__ + "static/media/wed1.ca4c0813.jpg";